import { Card, Container } from '@mui/material';
import PageHeader from 'components/PageHeader/PageHeader';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getQuizById } from 'services/quiz.service';
import { getQuizLastSessionId } from 'services/quiz_answer_log.service';
import { getUserById } from 'services/users.services';
import { QuestionType, QuizType } from 'types/quizes.type';
import QuizQuestion from './QuizQuestion';

const ViewQuizAnswers = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const selectedLanguage = language === 'hu' ? 'title_HU' : 'title_EN';
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [quiz, setQuiz] = useState<QuizType | null>(null);
  const [lastSessionId, setLastSessionId] = useState<string>('');
  const [user, setUser] = useState<any>();

  const fullPathName = pathname.split('/');

  //TODO: refactor hardcoded values
  const quizId = fullPathName[fullPathName.length - 4];
  const userId = fullPathName[fullPathName.length - 1];

  useEffect(() => {
    async function handleGetRequest() {
      setIsLoading(true);
      try {
        const responseQuiz = await getQuizById(quizId);
        const userData = await getUserById(userId);
        const responseLastSessionId = await getQuizLastSessionId({
          userId,
          quizId,
        });
        setUser(userData);
        setQuiz(responseQuiz.data);
        setLastSessionId(responseLastSessionId);
      } catch (error) {
        console.error('Error fetching quiz last session:', error);
      } finally {
        setIsLoading(false);
      }
    }

    handleGetRequest();
  }, []);

  return (
    <Container>
      <PageHeader
        title={`${quiz?.[selectedLanguage]} - ${user?.firstname} ${user?.lastname}`}
        hasButton={false}
        hasBackButton={true}
      />
      <Card
        style={{
          padding: '20px',
        }}
      >
        {quiz?.questions?.map((question: QuestionType) => {
          return (
            <QuizQuestion
              key={question.id}
              question={question}
              userId={userId}
              sessionId={lastSessionId}
            />
          );
        })}
      </Card>
    </Container>
  );
};

export default ViewQuizAnswers;
